import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { QualityControlService } from '../../services/quality-control/quality-control.service';
import { CQTradeItem } from '../../interfaces/quality-control';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import * as ScreeningActions from '../../../../store/screening/screening.actions';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { RepairRecordComponent } from '../../../../shared/components/repair-record/repair-record.component';

@Component({
  selector: 'app-quality-control-overview',
  templateUrl: './quality-control-overview.component.html',
  styleUrls: ['./quality-control-overview.component.sass'],
})
export class QualityControlOverviewComponent implements OnInit {
  orders: CQTradeItem[] = [];
  totalItems = 0;
  totalWaitingCQ = 0;
  totalCQRepair = 0;

  searchControl = new FormControl('');
  currentPage = 1;
  pageSize = 10;

  constructor(
    private qualityControlService: QualityControlService,
    private store: Store,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.loadingData();
  }

  loadingData() {
    const searchVal = this.searchControl.value?.trim();

    const params = {
      page: this.currentPage,
      pageSize: this.pageSize,
      tradeId: searchVal || '',
    };

    this.qualityControlService.listCQTrades(params).subscribe({
      next: (response: any) => {
        this.orders = response.data;
        this.totalItems = response.totalItems;
        this.totalWaitingCQ = response.totalItemsCQ;
        this.totalCQRepair = response.totalItemsRepair;
      },
      error: (err) => {
        this.toastr.error(err.errors[0]);
      },
    });
  }

  handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex + 1;
    this.loadingData();
  }

  onSearch() {
    this.currentPage = 1;
    this.loadingData();
  }

  initProcess(item: CQTradeItem) {
    const payload = {
      idTrade: item.tradeId,
      originalIMEI: item.imei,
      idOperation: null,
      idSubCategory: null,
      screeningStep: 'imei',
      isReappraisal: false,
      reasonOfReappraisal: '',
      isRepair: item.isRepair,
      classificationType: item.classification,
    };

    this.store.dispatch(new ScreeningActions.SetTrade(payload)).subscribe({
      next: () => {
        this.router.navigate(['processo/imei'], { relativeTo: this.route });
      },
    });
  }

  openAddModal() {
    const dialogRef = this.dialog.open(RepairRecordComponent, {
      width: '700px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.qualityControlService.repairRecord(result).subscribe({
          next: (response) => {
            this.toastr.success('Contagem de reparo cadastrado com sucesso.');
          },
          error: (err) => {
            this.toastr.error(err);
          },
        });
        this.loadingData();
      }
    });
  }
}
